import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rich-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.show)
      ? (_openBlock(), _createBlock(_component_ckeditor, {
          key: 0,
          "model-value": _ctx.editorData,
          disabled: _ctx.disabled,
          onReady: _ctx.onReady,
          editor: _ctx.editor,
          modelValue: _ctx.content,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
          config: _ctx.editorConfig,
          onInput: _ctx.contentInput
        }, null, 8, ["model-value", "disabled", "onReady", "editor", "modelValue", "config", "onInput"]))
      : _createCommentVNode("", true)
  ]))
}